import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from "@material-ui/core/styles";

import PaymentForm from './PaymentForm';

const useStyles = makeStyles(theme => ({
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    dialogActions: {
        justifyContent: 'center'
    },
    dialogButton: {
        minWidth: 200,
        maxWidth: '100%'
    }
}));


const PaymentCreateDialog = (props) => {
    const {
        open,
        handleClose,
        couple,
        payment,
        scroll
    } = props;

    const classes = useStyles();

    const handleSaveButtonClick = () => {
        handleClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen
            maxWidth='lg'
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>Create a Payment</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <PaymentForm couple={couple} payment={payment} handleSaveButtonClick={handleSaveButtonClick} />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose} variant="outlined" className={classes.dialogButton}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PaymentCreateDialog;
